function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $e3fbae3750e5f626$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"f9bx4":"shopping-list.a14d838d.js","7aOuY":"amazon1.875cac08.png","33UjE":"applebook1.09bf885c.png","jjvJg":"barnesnoble.84820a41.png","gB3Gx":"amazon@1x.100eb040.png","6p5Hd":"amazon@2x.fdf8ae2a.png","gLOvi":"applebook@1x.58f7dd67.png","ltMyQ":"applebook@2x.1c1863b9.png","kJVOm":"barnesnoble@1x.e62c1f9d.png","8ZirL":"barnesnoble@2x.84820a41.png","9v6fF":"symbol-defs.e6efdff2.svg","7pTZJ":"index.912c64fa.js","5Vwem":"index.3b688de3.js"}'));

parcelRequire("dTazW");
parcelRequire("bUb57");
parcelRequire("aFnU4");


parcelRequire("ghT7p");

var $dSs1Y = parcelRequire("dSs1Y");
var $c90d21968266ce81$exports = {};

$c90d21968266ce81$exports = new URL((parcelRequire("kyEFX")).resolve("7aOuY"), import.meta.url).toString();


var $1d76734563cfda77$exports = {};

$1d76734563cfda77$exports = new URL((parcelRequire("kyEFX")).resolve("33UjE"), import.meta.url).toString();


var $014a28d1a871741c$exports = {};

$014a28d1a871741c$exports = new URL((parcelRequire("kyEFX")).resolve("jjvJg"), import.meta.url).toString();


var $8657c96fc81da477$exports = {};

$8657c96fc81da477$exports = new URL((parcelRequire("kyEFX")).resolve("gB3Gx"), import.meta.url).toString();


var $bf2d03765356bc62$exports = {};

$bf2d03765356bc62$exports = new URL((parcelRequire("kyEFX")).resolve("6p5Hd"), import.meta.url).toString();


var $9c46c414ea554dcb$exports = {};

$9c46c414ea554dcb$exports = new URL((parcelRequire("kyEFX")).resolve("gLOvi"), import.meta.url).toString();


var $65b814978977e62c$exports = {};

$65b814978977e62c$exports = new URL((parcelRequire("kyEFX")).resolve("ltMyQ"), import.meta.url).toString();


var $ac39f52521fd53ad$exports = {};

$ac39f52521fd53ad$exports = new URL((parcelRequire("kyEFX")).resolve("kJVOm"), import.meta.url).toString();


var $e8008be4366c94b6$exports = {};

$e8008be4366c94b6$exports = new URL((parcelRequire("kyEFX")).resolve("8ZirL"), import.meta.url).toString();


var $10db6f286535da77$exports = {};

$10db6f286535da77$exports = new URL((parcelRequire("kyEFX")).resolve("9v6fF"), import.meta.url).toString();


const $001c118b8b2a009e$var$bookList = document.querySelector("#bookList");
const $001c118b8b2a009e$var$message = document.querySelector("#message");
// Отримуємо дані про книгу за її ідентифікатором
async function $001c118b8b2a009e$var$getBook(bookId) {
    const BASE_URL = "https://books-backend.p.goit.global/books/";
    const searchUrl = BASE_URL + bookId;
    try {
        const response = await fetch(searchUrl);
        if (!response.ok) throw new Error("Error");
        const data = await response.json();
        return data;
    } catch (err) {
        console.log(err.message);
        return null;
    }
}
// Завантажуємо масив ідентифікаторів книг з локального сховища
function $001c118b8b2a009e$var$loadBooksFromLocalStorage() {
    const booksFromLocalStorage = JSON.parse(localStorage.getItem("targetBooks")) || [];
    return booksFromLocalStorage;
}
// Оновлюємо відступ заголовку в залежності від того, чи додані книги до списку
function $001c118b8b2a009e$var$updateMainTitleMargin(isBooksAdded) {
    const mainTitle = document.querySelector(".shopping-list-title");
    if (isBooksAdded) mainTitle.style.marginBottom = "40px";
}
// Відображаємо карточки книг на сторінці
function $001c118b8b2a009e$var$displayBooksInShoppingList(bookIds) {
    $001c118b8b2a009e$var$bookList.innerHTML = "";
    (0, $dSs1Y.Loading).init();
    if (bookIds.length === 0) {
        $001c118b8b2a009e$var$message.style.display = "block";
        $001c118b8b2a009e$var$updateMainTitleMargin(false);
    } else {
        $001c118b8b2a009e$var$message.style.display = "none";
        bookIds.forEach(async (bookId)=>{
            try {
                const bookData = await $001c118b8b2a009e$var$getBook(bookId);
                $001c118b8b2a009e$var$createBookCard(bookData);
            } catch (err) {
                console.log(err.message);
            }
        });
        $001c118b8b2a009e$var$updateMainTitleMargin(true);
    }
    (0, $dSs1Y.Loading).remove();
}
// Створюємо HTML-структуру карточки книги
function $001c118b8b2a009e$var$createBookCard(book) {
    const storesImgs = [
        {
            name: "Amazon",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($c90d21968266ce81$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($8657c96fc81da477$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($bf2d03765356bc62$exports)))
            ]
        },
        {
            name: "Apple Books",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($1d76734563cfda77$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($9c46c414ea554dcb$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($65b814978977e62c$exports)))
            ]
        },
        {
            name: "Barnes and Noble",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($014a28d1a871741c$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($ac39f52521fd53ad$exports))),
                (0, (/*@__PURE__*/$parcel$interopDefault($e8008be4366c94b6$exports)))
            ]
        }
    ];
    /**шукаю посилання на сторінку магазинів і записую їх в попередній об'єкт */ storesImgs.forEach((i)=>{
        i.link = book.buy_links.find((item)=>item.name == i.name).url;
    });
    const storesListMarkup = storesImgs.map((i, index)=>{
        return `<li class="modal-shops-item">
            <a class="modal-link" href="${i.link}"
               target="_blank" name="${i.name}"
                        rel="noreferrer noopener">
                        <img class="modal-img-shop${index === 0 ? " first-img" : ""}" src="${i.img[0]}" alt="${i.name}" srcset="${i.img[1]} 1x, ${i.img[2]} 2x">
                    </a>
                </li>`;
    }).join("");
    const bookCard = document.createElement("div");
    bookCard.innerHTML = `
<div class="shopping-card">
      <img class="shopping-image" src="${book.book_image}" alt="${book.list_name}" id="${book._id}" width ="100px">
  <div class = "shopping-descr">
      <h2 class="book-card-title title-shop-list">${book.title}</h2>
      <h3 class="shopping-category title-shop-list">${book.list_name}</h3>
      <div class="shopping-description-container">  <p class="shopping-description">${book.description}</p> </div>
      <div class="link-book-shop">
      <span class="shopping-author">${book.author}</span>
          <ul class="list-shops">
                ${storesListMarkup}
            </ul>
            </div>
            </div>
      <button class="delete-button"><svg width="16" height="16" class="shopping-svg">
                    <use href="${0, (/*@__PURE__*/$parcel$interopDefault($10db6f286535da77$exports))}#icon-trash-03-1-1"></use></button>
    </div>
  `;
    $001c118b8b2a009e$var$bookList.appendChild(bookCard);
    const deleteButton = bookCard.querySelector(".delete-button");
    deleteButton.addEventListener("click", ()=>{
        $001c118b8b2a009e$var$removeBookFromLocalStorage(book._id);
        bookCard.remove();
        if ($001c118b8b2a009e$var$loadBooksFromLocalStorage().length === 0) $001c118b8b2a009e$var$message.style.display = "block";
    });
}
// Видаляємо ідентифікатор книги зі списку локального сховища
function $001c118b8b2a009e$var$removeBookFromLocalStorage(bookIdToRemove) {
    (0, $dSs1Y.Loading).init();
    const updatedBooks = $001c118b8b2a009e$var$loadBooksFromLocalStorage().filter((bookId)=>bookId !== bookIdToRemove);
    localStorage.setItem("targetBooks", JSON.stringify(updatedBooks));
    (0, $dSs1Y.Loading).remove();
}
// Завантажуємо ідентифікатори книг з локального сховища та відображає їх карточки
const $001c118b8b2a009e$var$bookIdsFromLocalStorage = $001c118b8b2a009e$var$loadBooksFromLocalStorage();
$001c118b8b2a009e$var$displayBooksInShoppingList($001c118b8b2a009e$var$bookIdsFromLocalStorage);
// Отримуємо всі карточки книг на сторінці
const $001c118b8b2a009e$var$bookCards = document.querySelectorAll(".book-card");
$001c118b8b2a009e$var$bookCards.forEach(async (bookCard)=>{
    const bookId = bookCard.querySelector(".shopping-image").id;
    try {
        const bookData = await $001c118b8b2a009e$var$getBook(bookId);
        if (bookData) $001c118b8b2a009e$var$createBookCard(bookData, bookCard);
    } catch (err) {
        console.log(err.message);
    }
});




//# sourceMappingURL=shopping-list.a14d838d.js.map
